import React from 'react';
import Box from '@mui/material/Box';
import CircularProgress from '@mui/material/CircularProgress';
import Typography from '@mui/material/Typography';

export type EnrichmentOverlayVariant =
  | 'enrichment'
  | 'prioritization'
  | 'both';

export interface EnrichmentOverlayProps {
  variant?: EnrichmentOverlayVariant;
  cellCount: number;
}

/**
 * Overlay badge shown in the bottom-right of the spreadsheet when enrichment or prioritization is in progress.
 */
const EnrichmentOverlay: React.FC<EnrichmentOverlayProps> = ({
  variant = 'enrichment',
  cellCount
}) => {
  const verb =
    variant === 'both'
      ? 'Processing'
      : variant === 'prioritization'
        ? 'Prioritizing'
        : 'Enriching';
  return (
    <Box
      sx={{
        position: 'absolute',
        bottom: 8,
        right: 8,
        display: 'flex',
        alignItems: 'center',
        gap: 1,
        bgcolor: (theme) => theme.customColors.themePrimary,
        color: 'primary.contrastText',
        borderRadius: 2,
        boxShadow: 2,
        px: 2,
        py: 1,
        zIndex: 1000
      }}
    >
      <CircularProgress size={16} sx={{ color: 'primary.contrastText' }} />
      <Typography variant="caption" sx={{ color: 'inherit', fontWeight: 600 }}>
        {cellCount > 0
          ? `${verb} ${cellCount} cell${cellCount !== 1 ? 's' : ''}…`
          : `${verb}…`}
      </Typography>
    </Box>
  );
};

export default EnrichmentOverlay;
